import { DefaultFileHandler, FileHandler, FileHandlerConfiguration, FileService, MemoryFileHandler } from '@philips-internal/oswald-ui-components';
import { HttpStatus } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { FileProviderData } from '../constants/file-provider-enum';

function setupFileService(): void {
  const myFileHandlerProvider = (): FileHandler => {
    const configuration = new FileHandlerConfiguration();
    configuration.previewUrl = '/preview?uri=';
    configuration.uploadUrl = '/patient-service/resources/files/upload/temp';
    configuration.uploadResponseState = HttpStatus.CREATED;
    configuration.removeUrl = '/patient-service/resources/files/remove';
    configuration.removeResponseState = HttpStatus.OK;

    const fileHandler = new DefaultFileHandler();
    fileHandler.setConfiguration(configuration);
    return fileHandler;
  };

  const memoryFileHandlerProvider = (): FileHandler => {
    const configuration = new FileHandlerConfiguration();

    const fileHandler = new MemoryFileHandler();
    fileHandler.setConfiguration(configuration);

    return fileHandler;
  }

  FileService.registerFileHandlerProvider({ name: FileProviderData.fileProviderMemory, provider: memoryFileHandlerProvider });
  FileService.registerFileHandlerProvider({ name: FileProviderData.fileProvider, provider: myFileHandlerProvider });
}

export { setupFileService };
